import React from "react";
import { Breadcrumb } from "antd";
import { NavLink } from "react-router-dom";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";

interface BreadcrumbItem {
    label: string;
    link?: string;
}

interface CustomBreadcrumbProps {
    items: BreadcrumbItem[];
    type?: string;
}

const CustomBreadcrumb: React.FC<CustomBreadcrumbProps> = ({ items, type }) => {
    return (
        <Breadcrumb>
            {items.map((item, index) => (
                <Breadcrumb.Item key={index}>
                    {item.link && (
                        <NavLink to={item.link}>{item.label}</NavLink>
                    )}
                </Breadcrumb.Item>
            ))}
            <BreadcrumbItem>
                <span style={{ textTransform: "capitalize" }}>{type}</span>
            </BreadcrumbItem>
        </Breadcrumb>
    );
};

export default CustomBreadcrumb;
